import { render, staticRenderFns } from "./NukeOverlay.vue?vue&type=template&id=23b4ffbf&"
import script from "./NukeOverlay.vue?vue&type=script&lang=js&"
export * from "./NukeOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports